<ng-container *ngIf="isLoading">
    <div class="loader-container" [ngClass]="{'non-transparent': isShowBackground}">
      <div class="rounded-2xl bg-white p-8 shadow-md">
        <mat-spinner diameter="50" color="primary" class="algo-loader"></mat-spinner>
      </div>
    </div>
</ng-container>
